import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  NEVER, Observable, catchError, throwError,
} from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);
  private router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status === HttpStatusCode.Unauthorized) {
          void this.authService.logout(window.location.origin);
          return NEVER;
        }

        // If the user's organization has not been approved, redirect to the waiting list
        if (
          error.status === HttpStatusCode.PreconditionFailed
          && error.error.error === 'error.custom.user_or_org_not_verified'
        ) {
          this.router.navigate(['/waiting-list']);
          return NEVER;
        }

        // rethrow the error, we don't want to handle it here
        return throwError(() => error);
      }),
    );
  }
}
